module.exports = {
      id: "unchecked-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-61689101322b9172a0a44b724a3b7060.svg#unchecked",
      toString: function () {
        return this.url;
      }
    }